export const LUT_TABLE_ID = "lookupTableID";
export const attributes = [
  {
    id: "title",
    title: "Title",
    type: "STRING",
    searchable: true
  },
  {
    id: "description",
    title: "Description",
    type: "STRING"
  },
  {
    id: "name",
    title: "Name",
    type: "STRING"
  },
  {
    id: "cache_id",
    title: "Cache",
    type: "STRING"
  },
  {
    id: "data_adapter_id",
    title: "Data Adapter",
    type: "STRING"
  }
];
export const lutListElements = {
  defaultLayout: {
    entityTableId: LUT_TABLE_ID,
    defaultPageSize: 20,
    defaultSort: { attributeId: "title", direction: "asc" },
    defaultDisplayedAttributes: ["title", "description", "name", "cache_id", "data_adapter_id"],
    defaultColumnOrder: ["title", "description", "name", "cache_id", "data_adapter_id"]
  }
};
